import React, { Component } from 'react';
import Collapsible from 'react-collapsible';

import stylesIcon from '../styles/header.scss';
import styles from './styles/submenu-title.scss';

import MenuLink from './menu-link';
import { isMobile } from '../../../helper';
import APP_DEFAULTS from '../../../constants/app-defaults';

export default class SubmenuTitle extends Component {
    constructor(props) {
        super();
        this.state = {
            index: (props.open) ? 1 : 0,
        };
        this.setIndex = this.setIndex.bind(this);
    }

    setIndex(index) {
        this.setState({ index });
    }

    shouldBeOpened() {
        return this.props.open;
    }

    render() {
        return (
            <div>
                <Collapsible
                    trigger={
                        this.props.isLink ? (
                            <MenuLink
                                className={this.props.className}
                                pathname={this.props.pathname}
                                search={this.props.search}
                                isActive={this.props.isActive}
                                setParams={this.props.setParams}
                                name={(
                                    <div className="text-justify">
                                        <p>
                                            {this.props.title}
                                            <i
                                                className={`${this.state.index === 1 ? 'pe-7s-angle-down' : 'pe-7s-angle-up'} pe-1x pe-va font-weight-bold pull-right 
                                                ${stylesIcon.angleDown} 
                                                ${styles.titleArrow}`}
                                            />
                                        </p>
                                    </div>
                                )}
                            />
                        ) : (
                            <div className={`text-justify ${styles.leftMenuTitleContainer}`}>
                                <p>
                                    {this.props.title}
                                    <i
                                        className={`${this.state.index === 1 ? 'pe-7s-angle-down' : 'pe-7s-angle-up'} pe-1x pe-va font-weight-bold pull-right 
                                        ${stylesIcon.angleDown} 
                                        ${styles.titleArrow}`}
                                    />
                                </p>
                            </div>
                        )
                    }
                    open={this.shouldBeOpened()}
                    onClose={() => this.setIndex(0)}
                    onOpen={() => this.setIndex(1)}
                    transitionTime={200}
                >
                    {this.props.children}
                </Collapsible>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/shared/secondary-menu/submenu-title.jsx
 **/